
const digest = '48faa35eaeda639b7f95aaaccd7188c43c506e9be51fd306852d7ba51b11e960';
const css = `._infoBlock_iv7j2_1 {
  --callout-box-padding-block: var(--spacer-4);
  --callout-box-padding-inline: var(--spacer-4);
  --callout-box-margin-block: var(--spacer-2);
  --callout-box-border-radius: var(--spacer-1);
  --callout-box-icon-padding: var(--spacer-3);
  padding: var(--callout-box-padding-block) var(--callout-box-padding-inline);
  margin: var(--callout-box-margin-block) 0;
  border-radius: var(--callout-box-border-radius);
  display: flex;

  & > span {
    flex: 1 1 auto;
  }

  &:before {
    font-family: 'Font Awesome 6 Pro';
    font-weight: 400;
    padding-right: var(--callout-box-icon-padding);
    color: var(--callout-box-icon-color);
    content: var(--callout-box-icon-content);
    float: left;
  }
}

._infoBlockType_iv7j2_26 {
  background-color: var(--theme-blue-background);
  border-color: var(--theme-blue-border);
  --callout-box-icon-color: var(--theme-blue-text);
  --callout-box-icon-content: '\\f05a';
  /* fa-info-circle */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}

._noteBlockType_iv7j2_35 {
  background-color: var(--theme-yellow-background);
  border-color: var(--theme-yellow-border);
  --callout-box-icon-color: var(--theme-yellow-text);
  --callout-box-icon-content: '\\f040';
  /* fa-pencil */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}

._warningBlockType_iv7j2_44 {
  background-color: var(--theme-red-background);
  border-color: var(--theme-red-border);
  --callout-box-icon-color: var(--theme-red-text);
  --callout-box-icon-content: '\\f071';
  /* fa-exclamation-triangle */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}

._tipBlockType_iv7j2_53 {
  background-color: var(--theme-green-background);
  border-color: var(--theme-green-border);
  --callout-box-icon-color: var(--theme-green-text);
  --callout-box-icon-content: '\\e2ca';
  /* fa-wand-magic-sparkles */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"infoBlock":"_infoBlock_iv7j2_1","infoBlockType":"_infoBlockType_iv7j2_26","noteBlockType":"_noteBlockType_iv7j2_35","warningBlockType":"_warningBlockType_iv7j2_44","tipBlockType":"_tipBlockType_iv7j2_53"};
export { css, digest };
  